<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="所在话题：" prop="topic_id">
                <el-select clearable v-model="model.topic_id" placeholder="请选择">
                    <el-option v-for="item in topicList" :key="'tp'+item.id" :label="item.topic_name" :value="item.id"> </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSelOk" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>

export default {
    name: 'selMomentTopic',
    props: {
        topicList: {
            type: Array,
            default() {
                return [];
            }
        },
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
        }
    },
    data() {
        return {
            showflag: false,
            model: {
                topic_id: '',
            }
        };
    },
    methods: {
        handleSelOk(){
            this.$emit("on-save-ok",{"topic_id": this.model.topic_id});
        },
        closeDialog(){
            this.$emit("on-close")
        }
    }
};
</script>